import React, { useMemo } from 'react';
import styled from './index._less';
import { ELoginType } from '../../../enum';
import QrcodeBtn from '../../../image/qrcode-btn.png';
import LoginBtn from '../../../image/login-btn.png';
import Reg from '../../../components/Reg';
import Login from '../../../components/Login';
import Qrcode from '../../../components/Qrcode';
import LoginAgreement from '../../../components/LoginAgreement';
import useLogin from '../../../hooks/use-login';
import SwitchBar from '../SwitchBar';


export default () => {

  const { loginType, handleSwitchLoginType } = useLogin();

  const LoginContent = useMemo(() => {
    if (loginType === ELoginType.Login) {
      return <Login />;
    }
    if (loginType === ELoginType.Reg) {
      return <Reg />;
    }
    if (loginType === ELoginType.Qrcode) {
      return <Qrcode />;
    }
    return <div/>
  }, [loginType])

  return (
      <>
      <div className="login-container">
        <div className="top-switch-icon">
          <img
            onClick={ handleSwitchLoginType }
            src={ loginType === ELoginType.Qrcode ? LoginBtn : QrcodeBtn }
            alt=""
          />
        </div>
        <SwitchBar />
        {/* 登录内容区 */}
        <div className="login-content">{ LoginContent }</div>
        {/* 登录底部 */}
        <LoginAgreement />
      </div>
      <style jsx>{ styled }</style>
    </>
  )
}
